import { extends as _extends } from '../../_virtual/_rollupPluginBabelHelpers.js';
import React__default, { forwardRef } from 'react';
import { Icon } from '../Icon/index.js';
import { Button } from '../Button/index.js';
import { checkForSemanticVariant, getTertiaryProps, getIconButtonStyles, getVariantSizeStyles } from './helpers.js';

/* ======================================= */
/* ======================================= */
/**
 * IconButton composes the Button component but renders only an icon.
 *
 * ### Documentation
 * - [Examples](https://blockparty.endpoint.com/components/icon-button#usage)
 * - [Props](https://blockparty.endpoint.com/components/icon-button#props)
 * <br />
 *
 */
const IconButton = /*#__PURE__*/forwardRef((props, forwardedRef) => {
  const {
    name,
    label,
    color,
    dataTestId = 'icon-button',
    iconSize = 'large',
    variantSize = 'large',
    ...filteredProps
  } = props;
  const {
    iconLeft,
    iconRight,
    loadingText,
    size = 'small',
    ...buttonProps
  } = filteredProps;
  const sizeObj = getIconButtonStyles(size);
  const variantSizeObj = getVariantSizeStyles(variantSize);
  const isSemanticVariant = checkForSemanticVariant(buttonProps.variant);
  const buttonSize = variantSize && isSemanticVariant ? variantSizeObj.buttonSize : sizeObj;
  const _iconSize = variantSize && isSemanticVariant ? variantSizeObj.iconSize : iconSize;
  const tertiaryProps = getTertiaryProps(buttonProps?.variant);
  return /*#__PURE__*/React__default.createElement(Button, _extends({
    ref: forwardedRef,
    "aria-label": label,
    "data-test-id": dataTestId,
    height: "initial"
  }, buttonSize, buttonProps, tertiaryProps), /*#__PURE__*/React__default.createElement(Icon, {
    "aria-hidden": label ? true : undefined,
    "aria-label": undefined,
    color: color,
    name: name,
    size: _iconSize
  }));
});

export { IconButton };
